
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5vSwz", function(module, exports) {
/* DateComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");


var $gdv5Z = parcelRequire("gdv5Z");

const $85a675280bdd34e2$var$styles = {
    dateWrapper: "_2rkolb4i _1h6d1j28"
};
const $85a675280bdd34e2$export$19285a5b05c4ea7c = ({ timestamp: timestamp })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        backgroundColor: "color.background.neutral",
        padding: "space.025",
        testId: "data-component",
        xcss: $85a675280bdd34e2$var$styles.dateWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cgtv4.FormattedDate), {
        value: new Date(parseInt(timestamp)).toLocaleString('en-US', {
            timeZone: 'Australia/Sydney'
        }),
        year: "numeric",
        month: "short",
        day: "numeric"
    }));
};
module.exports["DateComponent"] = $85a675280bdd34e2$export$19285a5b05c4ea7c;

});


//# sourceMappingURL=DateComponent.282e1f52.js.map
